import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { TextNumberComponent } from './components/algoria/app.textnumber.component';
import { AppAlertComponent } from './components/app.alert.component';
import { BlockableDivComponent } from './components/app.blockable.component';
import { AppChatLogComponent } from './components/app.chatlog.component';
import { AppCustomCodeComponent } from './components/app.customcode.component';
import { AppDataGridViewComponent } from './components/app.datagridview.component';
import { AppEditorComponent } from './components/app.editor.component';
import { GoogleAddressComponent } from './components/app.googleaddress.component';
import { GoogleMapAddressComponent } from './components/app.googlemapaddress.component';
import { AppHelpOnScreenComponent } from './components/app.help.onscreen.component';
import { PasswordFieldComponent } from './components/app.passwordfield.component';
import { AppPreloaderComponent } from './components/app.preloader.component';
import { AppViewConfigComponent } from './components/app.viewconfig.component';
import { GoogleMapAddressModalComponent } from './components/googlemapaddressmodal.component';
import { SelectUsersComponent } from './components/selectusers.component';
import { CharacterCounterDirective } from './directives/CharacterCounterDirective';
import { NativeElementInjectorDirective } from './directives/NativeElementInjectorDirective ';
import { SharedRoutingModule } from './shared-routing.module';
import { DynamicCatalogViewComponent } from './components/dynamiccatalogscomponents/dynamiccatalog-view.component';
import { DynamicCatalogFormComponent } from './components/dynamiccatalogscomponents/dynamiccatalog-form.component';
import { DynamicCatalogFormModalComponent } from './components/dynamiccatalogscomponents/dynamiccatalog-form-modal.component';
import { BusquedaPacientesComponent } from '../app/_components/consultas/pacientes/busquedapacientes.component';
import { BusquedaPacientesGridComponent } from '../app/_components/consultas/pacientes/busquedapacientes-grid.component';
import { BusquedaPacientesUrgenciasGridComponent } from '../app/_components/consultas/pacientes/busquedapacientes-urgencias-grid.component';
import {
    BusquedaPacientesIMSSGridComponent
} from '../app/_components/consultas/pacientes/busquedapacientes-imss-grid.component';
import {
    PacienteSeleccionadoComponent
} from '../app/_components/consultas/pacientes/paciente-seleccionado.component';
import {
    BusquedaCausasInclusionProgramaGridComponent
} from '../app/_components/consultas/causasinclusionprograma/busquedacausasinclusionprograma-grid.component';
import {
    BusquedaEventosGridComponent
} from '../app/_components/consultas/eventos/busquedaeventos-grid.component';
import { TabViewModule } from 'primeng/tabview';
import { ToolbarModule } from 'primeng/toolbar';
import { BusquedaMedicamentosGridComponent } from '../app/_components/consultas/medicamentos/busquedamedicamentos-grid.component';
import { BusquedaPacientesLocalesGridComponent } from '../app/_components/consultas/pacientes/busquedapacientes-locales-grid.component';
import { MonitorMaquinasBellcoComponent } from '../app/_components/consultas/monitormaquinasbellco/monitormaquinasbellco.component';
import { CitasNoOtorgadasComponent } from '../app/_components/consultas/citasnootorgadas/citasnootorgadas.component';
import { EditPatientComponent } from '../app/catalogs/patients/editpatient.component';
import { PatientsMedicationsComponent } from '../app/catalogs/patients/medications/patients-medications.component';
import { EditPatientMedicationsComponent } from '../app/catalogs/patients/medications/editpatientmedications.component';
import { GlobalDropdownTooltipDirective } from './directives/global-dropdown-tooltip.directive';
import { GlobalCalendarTooltipDirective } from './directives/global-calendar-tooltip.directive';
import { GlobalInputNumberSpinnerTooltipDirective } from './directives/global-inputnumber-spinner-tooltip.directive';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,

        DialogModule,
        ButtonModule,
        SidebarModule,
        CheckboxModule,
        BlockUIModule,
        TableModule,
        TabViewModule,
        InputTextModule,
        VirtualScrollerModule,
        ScrollerModule,
        MenubarModule,
        MenuModule,
        InputTextareaModule,
        EditorModule,
        FileUploadModule,
        PanelModule,
        OverlayPanelModule,
        InputMaskModule,
        ScrollPanelModule,
        PasswordModule,
        DividerModule,
        ListboxModule,
        CalendarModule,
        InputSwitchModule,
        InputNumberModule,
        MultiSelectModule,
        RadioButtonModule,
        AutoCompleteModule,
        DropdownModule,
        ToolbarModule,
        SharedRoutingModule,
        OrderListModule,
        GoogleMapsModule
    ],
    declarations: [
        GlobalDropdownTooltipDirective,
        GlobalCalendarTooltipDirective,
        GlobalInputNumberSpinnerTooltipDirective,
        AppAlertComponent,
        AppHelpOnScreenComponent,
        AppDataGridViewComponent,
        SelectUsersComponent,
        AppEditorComponent,
        TextNumberComponent,
        GoogleAddressComponent,
        GoogleMapAddressComponent,
        GoogleMapAddressModalComponent,
        AppChatLogComponent,
        BlockableDivComponent,
        PasswordFieldComponent,
        AppPreloaderComponent,
        AppCustomCodeComponent,
        NativeElementInjectorDirective,
        AppViewConfigComponent,
        CharacterCounterDirective,
        DynamicCatalogViewComponent,
        DynamicCatalogFormComponent,
        DynamicCatalogFormModalComponent,
        BusquedaPacientesComponent,
        BusquedaPacientesGridComponent,
        BusquedaPacientesUrgenciasGridComponent,
        BusquedaPacientesIMSSGridComponent,
        PacienteSeleccionadoComponent,
        BusquedaEventosGridComponent,
        BusquedaCausasInclusionProgramaGridComponent,
        BusquedaMedicamentosGridComponent,
        BusquedaPacientesLocalesGridComponent,
        MonitorMaquinasBellcoComponent,
        CitasNoOtorgadasComponent,
        EditPatientComponent,
        PatientsMedicationsComponent,
        EditPatientMedicationsComponent
    ],
    entryComponents: [
        GoogleMapAddressModalComponent,
        DynamicCatalogFormModalComponent
    ],
    exports: [
        GlobalDropdownTooltipDirective,
        GlobalCalendarTooltipDirective,
        GlobalInputNumberSpinnerTooltipDirective,
        AppAlertComponent,
        AppHelpOnScreenComponent,
        AppDataGridViewComponent,
        SelectUsersComponent,
        AppEditorComponent,
        TextNumberComponent,
        GoogleAddressComponent,
        GoogleMapAddressComponent,
        AppChatLogComponent,
        BlockableDivComponent,
        PasswordFieldComponent,
        AppPreloaderComponent,
        AppCustomCodeComponent,
        NativeElementInjectorDirective,
        AppViewConfigComponent,
        CharacterCounterDirective,
        DynamicCatalogViewComponent,
        DynamicCatalogFormComponent,
        BusquedaPacientesComponent,
        BusquedaPacientesGridComponent,
        BusquedaPacientesUrgenciasGridComponent,
        BusquedaPacientesIMSSGridComponent,
        PacienteSeleccionadoComponent,
        BusquedaEventosGridComponent,
        BusquedaCausasInclusionProgramaGridComponent,
        BusquedaMedicamentosGridComponent,
        BusquedaPacientesLocalesGridComponent,
        MonitorMaquinasBellcoComponent,
        CitasNoOtorgadasComponent
    ]
})
export class SharedModule { }

